import { useTranslation } from "react-i18next"

import { FilterChip } from "@/components/filter-chip"
import { FilterToolbar } from "@/components/filter-toolbar"
import { ORDER_STATUS_BUCKETS } from "@/features/orders/lib/order-status"

export interface OrdersFiltersValue {
  search: string
  status: string
  cooperative: string
}

interface OrdersSearchFiltersProps {
  value: OrdersFiltersValue
  onChange: (next: OrdersFiltersValue) => void
  cooperativeOptions: { id: string; name: string }[]
}

export function OrdersSearchFilters({
  value,
  onChange,
  cooperativeOptions,
}: OrdersSearchFiltersProps) {
  const { t } = useTranslation(["orders", "common"])
  const allLabel = t("common.all", { ns: "common" })

  let activeCount = 0
  if (value.status !== "all") activeCount += 1
  if (value.cooperative !== "all") activeCount += 1

  return (
    <FilterToolbar
      search={value.search}
      onSearchChange={(v) => onChange({ ...value, search: v })}
      searchPlaceholder={t("search.placeholder")}
      activeFilterCount={activeCount}
      resetLabel={t("search.clearFilters")}
      onReset={() =>
        onChange({ search: "", status: "all", cooperative: "all" })
      }
    >
      <FilterChip
        label={t("search.statusLabel")}
        value={value.status}
        onValueChange={(v) => onChange({ ...value, status: v })}
        options={ORDER_STATUS_BUCKETS.map((b) => ({
          value: b,
          label: t(`statusBucket.${b}`),
        }))}
        allLabel={allLabel}
      />
      <FilterChip
        label={t("search.cooperativeLabel")}
        value={value.cooperative}
        onValueChange={(v) => onChange({ ...value, cooperative: v })}
        options={cooperativeOptions.map((c) => ({
          value: c.id,
          label: c.name,
        }))}
        allLabel={allLabel}
      />
    </FilterToolbar>
  )
}
